// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"7a7777e5","155":"8bab9e93","392":"2403c465"}[chunkId] + ".chunk.js";
};